import type { Job } from "~/db/types";
import { TypographyH3 } from "./ui/typography/h3";
import { SaveButton } from "./saveButton";
import { BanknoteIcon, Check, Clock10Icon, MapPinIcon } from "lucide-react";
import { salaryTimePeriodsEnum } from "~/utils/consts";
import { Badge } from "./ui/badge";
import formatDistance from "date-fns/formatDistance";
import ShareDropDown from "./shareDropdownMenu";
import { Button } from "./ui/button";
import { Link } from "@remix-run/react";

export function JobArticle({ job }: { job: Job }) {
  return (
    <Link to={`../job/${job.id}`}>
      <article className="px-4 py-6">
        <header className="flex justify-between -mb-1">
          <TypographyH3 className="text-lime-800 font-bold hover:underline">
            {job.title}
          </TypographyH3>
          <SaveButton job={job} />
        </header>
        <p className="mb-2">{job.schoolName}</p>
        <ul className="mb-1">
          <li className="flex items-center">
            <MapPinIcon className="mr-2 text-lime-600" size={18} />
            <p>{job.location}</p>
          </li>
        </ul>
        <ul>
          <li className="flex items-center">
            <BanknoteIcon className="mr-2 text-lime-600" size={18} />
            <p>
              ₹{" "}
              {job.salary?.split("-")[0] === "0" || job.salary === ""
                ? "Salary Negotiable"
                : job.salary +
                  " " +
                  salaryTimePeriodsEnum[
                    job.salaryTimePeriod as keyof typeof salaryTimePeriodsEnum
                  ]}{" "}
            </p>
          </li>
        </ul>
        <div
          className="ql-editor -ml-4 max-h-48 !overflow-y-hidden"
          dangerouslySetInnerHTML={{ __html: job.shortDescription }}
        />
        <footer>
          <ul className="flex items-center gap-2">
            <li>
              <Badge variant="outline" className="bg-slate-100">
                <Clock10Icon size={16} className="mr-2" />
                {formatDistance(job.postedAt! * 1000, new Date(), {
                  includeSeconds: false,
                  addSuffix: true,
                })}
              </Badge>
            </li>
            <li>
              <ShareDropDown job={job} />
            </li>
            <li>
              {job.applied ? (
                <div className="p-2 flex">
                  <Check color="rgb(77 124 15)" /> Applied
                </div>
              ) : (
                <Button variant={"ghost"}>Easy Apply</Button>
              )}
            </li>
          </ul>
        </footer>
      </article>
    </Link>
  );
}
